export default __webpack_public_path__ + "static/media/visibility.b7ba5b11.svg";